export const ONBOARDING_STATE_KEY = 'flow_onboarding_state';
export const PENDING_POLL_MS = 15000;

export function createOnboardingState() {
    const bytes = new Uint8Array(24);
    crypto.getRandomValues(bytes);
    const state = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    sessionStorage.setItem(ONBOARDING_STATE_KEY, state);
    return state;
}

export function peekOnboardingState() {
    return sessionStorage.getItem(ONBOARDING_STATE_KEY);
}

export function clearOnboardingState() {
    sessionStorage.removeItem(ONBOARDING_STATE_KEY);
}

export function buildCoreOnboardingUrl({ origin, applicationId, returnUrl, state }) {
    const params = new URLSearchParams({ returnUrl, state });
    const base = String(origin || '').replace(/\/+$/, '');
    return `${base}/#/onboarding/${applicationId}?${params.toString()}`;
}

export function getOnboardingReturnUrl() {
    // Must match the origin that stored CSRF state, or Core's callback cannot be verified.
    return window.location.origin.replace(/\/+$/, '');
}

export function isMissingApplicationAccess(message) {
    return /access to this application/i.test(String(message || ''));
}

export function parseHandoffParams(location = window.location) {
    const search = new URLSearchParams(location.search || '');
    let code = search.get('code');
    let state = search.get('state');
    let error = search.get('error');
    let errorDescription = search.get('error_description') || search.get('errorDescription');

    const hash = (location.hash || '').replace(/^#/, '');
    if (hash) {
        const query = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : hash;
        const hashParams = new URLSearchParams(query);
        code = code || hashParams.get('code');
        state = state || hashParams.get('state');
        error = error || hashParams.get('error');
        errorDescription = errorDescription
            || hashParams.get('error_description')
            || hashParams.get('errorDescription');
    }

    return { code, state, error, errorDescription };
}

export function hasHandoffReturn(location = window.location) {
    const { code, error } = parseHandoffParams(location);
    return Boolean(code || error);
}

export function extractHandoffErrorMessage(payload, fallback = 'Could not complete sign-up. Please try again.') {
    if (!payload || typeof payload !== 'object') {
        return fallback;
    }
    const message = payload.error || payload.message;
    if (Array.isArray(message) && message.length > 0) {
        return String(message[0]);
    }
    if (typeof message === 'string' && message.trim()) {
        return message;
    }
    return fallback;
}
